import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6641ea3a")

_pushScopeId("data-v-6641ea3a")
const _hoisted_1 = { class: "digest-page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-stretch" }
const _hoisted_4 = { class: "digest__content" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BreadCrumbs = _resolveComponent("BreadCrumbs")
  const _component_SectionTitle = _resolveComponent("SectionTitle")
  const _component_TabHead = _resolveComponent("TabHead")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_BreadCrumbs, { links: [{ to: 'digest', name: 'adaptiveTop.digest' }] }),
      _createVNode(_component_SectionTitle, {
        title: _ctx.$t('pages.digest.title1'),
        class: "digest-page__title"
      }, null, 8, ["title"]),
      _createVNode(_component_TabHead, {
        active: _ctx.activeTab,
        items: _ctx.digestCateg,
        type: 'small',
        class: "digest-page__tab-head",
        onSelect: _cache[1] || (_cache[1] = $event => (_ctx.activeTab = $event))
      }, null, 8, ["active", "items"]),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.digests, (digest) => {
          return (_openBlock(), _createBlock("div", {
            key: digest.id,
            class: [digest.col]
          }, [
            _createVNode(_component_router_link, {
              to: _ctx.isPdf ? { name: 'digestIdPdf' } : {
            name: 'digestId',
            params: { id: digest.id, categoryId: digest.report_category_id }
          },
              class: "digest"
            }, {
              default: _withId(() => [
                _createVNode("img", {
                  class: "digest__photo",
                  src: require('@/assets/images/' + digest.image),
                  alt: ""
                }, null, 8, ["src"]),
                _createVNode("div", _hoisted_4, _toDisplayString(digest.name_ru || digest.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ], 2))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
})